// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLayout_root__1CwUs","content":"AppLayout_content__2vlai"};